import { createPlatePlugin } from 'platejs/react';
import { ImageElement } from '../ImageElement/ImageElement';

// Shared node type/key for the image plugin — used by both the plugin
// registration and the HTML deserializer so the string is defined once.
export const IMAGE_PLUGIN_KEY = 'image';

// Custom void element plugin for inline images. We don't install
// @platejs/media — this is the bare minimum the one-pager needs:
// a `{ type: 'image', url, children: [{ text: '' }] }` block that
// renders <img> and round-trips through the Slate ↔ Plate
// serializers. URL lifecycle (base64 → docId → presigned URL) is
// handled by the existing imageUploadService.
export const ImagePlugin = createPlatePlugin({
    key: IMAGE_PLUGIN_KEY,
    node: {
        isElement: true,
        isVoid: true,
        type: IMAGE_PLUGIN_KEY,
    },
    parsers: {
        html: {
            deserializer: {
                rules: [{ validNodeName: 'IMG' }],
                // Skip <img> elements with no src — getAttribute('src') is null
                // for them, and a null url would otherwise flow into the upload
                // path. Returning undefined omits the node entirely.
                parse: ({ element }: { element: HTMLElement }) => {
                    const url = element.getAttribute('src');
                    if (!url) return undefined;
                    return { type: IMAGE_PLUGIN_KEY, url };
                },
            },
        },
    },
}).withComponent(ImageElement);
